import React, { useState } from 'react';
import {
  AppBar, Toolbar, Typography, Grid, IconButton, Drawer, Box, CssBaseline, List, ListItem, ListItemText, Divider,
  Collapse,
  Menu,
  MenuItem
} from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';
import { MainContent } from './MainContent';

import { ReportView } from './ReportView';
import { BanquetView } from './BanquetView';
import WSSCheckBoxField from '../../Components/CheckBox/WSCheckBox';
import { BackendSettings } from './BackendSettings';
import { BackendSideBar } from './BackendSidebar';
import { UserRoleList } from './UserRole/UserRoleList';
import { UserOperationList } from './UserConfiguration/UserOperation/UserOperationList';
import { StoreList } from './UserConfiguration/StoreOperation/StoreList';
import { OutletList } from './UserConfiguration/OutletOperation/Outlet';

export const AppBarHome: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedContent, setSelectedContent] = useState("dashboard"); // Track selected content
  const [isUserOperationVisible, setIsUserOperationVisible] = useState(true);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [drawerOpen, setDrawerOpen] = useState(false);
 
  // Function to toggle the drawer
  const toggleDrawer = (open: any) => () => {
    setDrawerOpen(open);
  };
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

 
  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleSubMenuClick = (menu: string) => {
    setSelectedContent(menu);
  };
  return (
    <Grid sx={{ display: 'flex', minHeight: '100vh' }}>
      

      {/* AppBar at the Top */}
      <AppBar  sx={{ backgroundColor: 'green', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Grid container alignItems="center" sx={{ width: 'auto' }}>
            <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 1 }} onClick={toggleSidebar}>
              <WSIcons.MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div">
              willsoar
            </Typography>
          </Grid>

          {/* Right Side: Icons */}
          <Grid container justifyContent="flex-end" alignItems="center" spacing={1} sx={{ width: 'auto' }}>
            <Grid item>
              <IconButton color="inherit" onClick={() => setSelectedContent("dashboard")}>
                <WSIcons.Dashboard />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton color="inherit" onClick={() => setSelectedContent("report")}>
                <WSIcons.Report />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton color="inherit" onClick={() => setSelectedContent("Banquet")}>
                <WSIcons.RoomServiceIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton color="inherit">
                <WSIcons.NotificationsIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton color="inherit">
                <WSIcons.AccountCircleIcon /> <Typography>Admin</Typography>
              </IconButton>
            </Grid>
            <Grid item display="flex" alignItems="center">
              <IconButton color="inherit" onClick={handleMenuClick}>
                <WSIcons.ArrowDropDownIcon />
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <MenuItem><WSIcons.SettingsIcon /> <Typography> Change Password</Typography> </MenuItem>
                <MenuItem><WSIcons.ScreenRotationAltIcon /> <Typography> Shift Report</Typography> </MenuItem>
                <MenuItem><WSIcons.LogOut /> <Typography> Log Out</Typography> </MenuItem>
                <MenuItem><WSIcons.CloseIcon /> <Typography> Close</Typography> </MenuItem>
              </Menu>
            </Grid>
            <Grid item>
              <IconButton color="inherit" onClick={toggleDrawer(true)}>
                <WSIcons.Threedot />
              </IconButton>
              <BackendSettings open={drawerOpen} onClose={toggleDrawer(false)} />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <BackendSideBar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} onMenuClick={handleSubMenuClick}/>

      {/* Main Content */}
      <Grid component="main" sx={{ flexGrow: 1, bgcolor: '#eaeaea', p: 2 }}>
        {selectedContent === "dashboard" && <MainContent sidebarOpen={sidebarOpen} />}
        {selectedContent === "report" && <ReportView />}
        {selectedContent === "Banquet" && <BanquetView />}
        {selectedContent === "useroperation" && <UserOperationList onClose={() => setIsUserOperationVisible(false)}/>}
        {selectedContent === "userrole" && <UserRoleList onClose={() => setIsUserOperationVisible(false)}/>}
        {selectedContent === "store" && <StoreList onClose={() => setIsUserOperationVisible(false)}/>}
        {selectedContent === "outlet" && <OutletList onClose={() => setIsUserOperationVisible(false)}/>}

      </Grid>
    </Grid>
  );
};

export default AppBarHome;
